import request from './http';

// 查询主组织部门列表
export const getDepartInfoList = data => {
  return request({
    method: 'get',
    url: '/auth/access/findAllocationDepartInfo?userCode=' + data
  })
}
//移动部门组织
export const handleDrop = data => {
  return request({
    method:'post',
    url:'auth/access/moveMainGroupInfo',
    data
  })
}
// 分页查询主组织用户信息
export const pageFindUserList = data => {
  return request({
    method: 'post',
    url: '/auth/access/pageFindUserInfo',
    data
  })
}

//更新用户状态
export const updateUserStatus = data => {
  return request({
    method: 'get',
    url: '/auth/user/updateUserInfo?companyId=' + data.companyId + "&userId=" + data.userId + "&userStatus=" + data.userStatus
  })
}


// 根据用户，角色查询关联的系统，角色信息
export const findSystemInfo = data => {
  return request({
    method: 'get',
    url: 'auth/access/findSystemInfo?roleName=' + data.roleName + "&userCode=" + data.userCode,
  })
}

// 查询所有的系统用户角色信息
export const getAllCompanyInfo = data => {
  return request({
    method: 'get',
    url: '/auth/access/findSystemItemInfo?roleName=' + '' + '&userCode=' + data.userCode,
  })
}

//查询所有用户列表
export const findUserInfo = data => {
  return request({
    method: 'get',
    url: '/auth/copy/findUserInfo'
  })
}
//复制权限
export const copyJurisdiction = data => {
  return request({
    method: 'get',
    url: '/auth/copy/copyAccessInfo?userCode=' + data.userCode + "&userCodes=" + data.userCodes
  })
}
//判断是否存在部门
export const isPosition = data => {
  return request({
    method: 'get',
    url: 'auth/access/validIsDepartment?userId=' + data.userId
  })
}

// 权限配置
export const configOrganize = data => {
  return request({
    method: 'post',
    url: '/auth/access/accessConfigInfo',
    data
  })
}

// 查询用户在某个系统下的权限菜单
export const findMenuInfo = data => {
  return request({
    method: 'get',
    url: '/auth/access/findMenuInfo?companyId=' + data.companyId + "&userId=" + data.userId,
  })
}

// 根据菜单ID查询按钮列表
export const findMenuList = data => {
  return request({
    method: 'get',
    url: '/auth/access/findMenuButtonInfo?companyId=' + data.companyId + "&menuId=" + data.menuId + "&userId=" + data.userId
  })
}

// 自定义权限配置用户查询
export const findPageUserInfo = data => {
  return request({
    method: 'post',
    url: '/auth/access/pageFindDefineInfo',
    data
  })
}

// 特殊权限的配置
export const defineAccessConfig = data => {
  return request({
    method: 'post',
    url: '/auth/access/defineAccessConfig',
    data
  })
}

// 继承权限
export const inheritPermission = data => {
  return request({
    method: 'get',
    url: '/auth/access/inheritanceUserInfo?userId=' + data
  })
}

//转移部门
export const transJurisdiction = data => {
  return request({
    method: 'get',
    url: 'auth/access/adjustDepartment?groupId=' + data.groupId + "&userCode=" + data.userCode,
  })
}

//重置密码
export const resetPasswordMange = data => {
  return request({
    method: 'get',
    url: 'auth/user/resetPassWord?userId=' + data.userId + "&passWord=" + data.passWord
  })
}

//删除部门
export const removeNode = data => {
  return request({
    method: 'get',
    url: 'auth/depart/deleteDepart?companyId=' + data.companyId + "&groupId=" + data.groupId
  })
}

//添加部门
export const appendNode = data => {
  return request({
    method: 'post',
    url: 'auth/access/addDepartInfo',
    data
  })
}

//编辑部门
export const editNode = data => {
  return request({
    method: 'post',
    url: 'auth/access/modifyDepartInfo',
    data
  })
}

// 查询所有系统
export const getAllSystemList = data => {
  return request({
    method: 'get',
    url: '/auth/access/findSpecialSystemInfo?userCode=' + data
  })
}

// 查询用户在某个系统下所有的菜单
export const getSystemAllMenu = data => {
  return request({
    method: 'get',
    url: '/auth/access/findAllMenuInfo?companyId=' + data.companyId + "&userId=" + data.userId
  })
}

// 取消单个系统的特殊权限
export const cancelSpecialUserInfo = data => {
  return request({
    method: 'get',
    url: '/auth/access/cancelSpecialUserInfo?companyId=' + data.companyId + "&userId=" + data.userId
  })
}
